<script lang="ts">
import type { StudyTimelineListItem } from '$lib/components/study/slide-layout-types'

/** Vertical `.tli` list: period label + trusted HTML body (outlook / roadmap). */
interface Props {
  items: readonly StudyTimelineListItem[]
  wrapClass?: string
  wrapStyle?: string
}

let { items, wrapClass = '', wrapStyle }: Props = $props()
</script>

<div class={wrapClass} style={wrapStyle}>
  {#each items as { period, bodyHtml }}
    <div class="tli">
      <div class="ty">{period}</div>
      <div class="tt">{@html bodyHtml}</div>
    </div>
  {/each}
</div>
